var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC0201;}\n\t.st1{fill:#FECD17;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2406_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2409_",
    d: "M256,0C144.8,0,49.8,71.3,14.7,170.7h482.7C462.1,71.3,367.2,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2408_",
    className: "st0",
    d: "M512,256c0-29.9-5.2-58.7-14.6-85.3H14.7C5.2,197.3,0,226.1,0,256c0,29.9,5.2,58.6,14.7,85.3 h482.7C506.8,314.6,512,285.9,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2407_",
    className: "st1",
    d: "M14.7,341.3C49.8,440.6,144.8,512,256,512c111.2,0,206.1-71.4,241.3-170.7H14.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.0ec851215202feeafc3ae928101055c7.svg";
export { ForwardRef as ReactComponent };